export default __webpack_public_path__ + "static/media/Autokritigallery_23.b6c8cbdc.jpg";